/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .operation-type-icon{margin-left:30px;margin-right:0;margin-top:10px;width:30px;height:30px}[_nghost-%COMP%]     .add-operation{position:absolute;right:0;height:100%;width:30px;display:block;z-index:1}[_nghost-%COMP%]     .add-operation svg{height:100%;width:100%;fill:#969da1}"];
export { styles as styles };
